export default {
    "+": "+",
    "-": "-",
    "*": "*",
    "/": "/",
    "min": "Min",
    "max": "Max",
    "sqrt": "SQRT",
    "pow": "POW",
    "exp": "EXP",
    "ln": "LN",
    "log": "LOG",
    "sgn": "SGN",
    "abs": "ABS",
    "mod": "MOD",
    "floor": "FLOOR",
    "ceil": "CEIL",
    "round": "ROUND",
    "avg": "AVG",
    "concat": "CONCAT",
    "trim": "TRIM",
}